import { OrbSetupModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/orb/OrbSetupModule';
import { OrbDetailsComponent } from '../../../../components/displays/alerts/components/alertWatchlistComponent/setupDetailsComponents/orb/OrbDetailsComponent';
import { parseOrbNotificationDetails } from '../../../../components/displays/alerts/components/notificationComponent/notificationListItem/notificationSetupParsers/parseOrbNotificationDetails';
import { OrbLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/OrbLine';
import { OrbTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/OrbTacticPanel';
import { OrbWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/OrbModule/wrapper/OrbWrapper';
import OrbDocs from '../../../../components/forms/tradeplans/documentation/OrbDocumentation';
import { determineOrbCandleDuration } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/orb/determineOrbCandleDuration';
import { determineOrbTimeUnit } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/orb/determineOrbTimeUnit';
import { orbDetailParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/orb/orbDetailParser';
import { OrbData } from './orbData';
import { validateOrb } from './validateOrb';

export const Orb = {
  //data class
  dataStore: OrbData,

  //string constants
  name: 'ORB',
  tacticLabel: 'ORB',
  addTacticLabel: 'Add ORB',
  category: 'Setup',

  //components
  tradePlanFormModule: null,
  tacticPanel: OrbTacticPanel,
  addTacticPanel: null,
  wrapper: OrbWrapper,
  chartSoftOrderComponent: OrbLine,
  documentation: OrbDocs,
  alertDetailsComponent: OrbSetupModule, //todo
  alertTableSetupComponent: OrbDetailsComponent,

  //functions
  setupDetailParser: orbDetailParser, //todo
  setupNotificationParser: parseOrbNotificationDetails,
  validationFunction: validateOrb,
  determineTimeUnit: determineOrbTimeUnit,
  determineCandleDuration: determineOrbCandleDuration,
};
